import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import { setupDirectives } from './directives'
import { router, setupRouter } from './router'
import { setupStore } from './store'
import { setup } from './utils/vab'
import { setupMicroApp } from '@/micro/microInit'
import { setupElementPlus } from '@/plugins/elementPlus'
import { setupSjzyUi } from '@/plugins/sjzyUi'
import { setupSjzyLibrary } from '@/plugins/sjzyLibrary'
import { setupI18n } from '@/i18n'
import { setupVxeTable } from '@/plugins/VxeTable'
import { setupLanguage } from '@/plugins/language'
import { getMicroData } from '@/composables/event/useMicroApp'
import { setupWebTracing } from '@/plugins/tracing'
import 'uno.css'
import 'driver.js/dist/driver.css'
import '@/styles/css/global.css'
import '@/styles/scss/main.scss'
import '../iconfont/iconfont.css'
import '../iconfont/iconfont.js'
import '@sjzy/ui/es/style.css'

// 流程面板 图标
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'

import './assets/crmIconfont/iconfont.css'
import './assets/crmIconfont/iconfont.js'
import '@/styles/css/sjzy-ylwicon-alias.css'

// 在微前端环境中，并且isLoadCommonCss为true时，加载全局样式。
if (
  !window.__MICRO_APP_ENVIRONMENT__
  || (window.__MICRO_APP_ENVIRONMENT__ && getMicroData()?.isLoadCommonCss)
) {
  import('@/styles/css/theme.css')
}

async function setupApp() {
  const app = createApp(App)

  const settingsStore = useSettingsStore()
  const { initTheme } = settingsStore
  initTheme()
  setup(app)
  /** language */
  setupLanguage(app)
  /** WebTracing */
  setupWebTracing(app)
  /** createHead */
  app.use(createHead())
  /** directive */
  setupDirectives(app)
  /** VxeTable */
  setupVxeTable(app)
  /** ElemenPlus */
  setupElementPlus(app)
  /** SjzyUi */
  setupSjzyUi(app)
  /** SjzyLibrary */
  setupSjzyLibrary()
  /** pinia */
  setupStore(app)
  /** router */
  await setupRouter(app)
  /** i18n */
  setupI18n(app)
  /** mount */
  app.mount('#micro-crm-app')
  /** microapp */
  setupMicroApp(app, router)
}

setupApp()
